<template>
  <v-container fill-height fluid>
    <v-overlay :absolute="false" :value="!iframe.loaded">
      <v-alert
        >CARREGANDO &nbsp;&nbsp;
        <v-progress-circular indeterminate></v-progress-circular
      ></v-alert>
    </v-overlay>
    <v-row align="center" justify="center">
      <v-col cols="12" align="center">
        <material-card color="primary">
          <template v-slot:header>
            <div class="px-3">
              <div class="title font-weight-bold mb-2">
                Painel PDI/PPI {{ desiredTitle }}
              </div>
              <!--div class="category font-weight-thin">
                        O painel de análise desse indicador ainda está em construção.
                        Você pode verificar todos indicadores em 
                        <a
                                class="white--text"
                                href="https://proplan.ufms.br/indicadores-do-pdi-ppi/"
                                target="_blank"
                        >Indicadores do Plano de Desenvolvimento Institucional (PDI) Integrado ao Projeto Pedagógico Institucional (PPI) / 2020 – 2024
                        </a>
                    </div-->
            </div>
          </template>
          <v-breadcrumbs :items="bread">
            <template v-slot:divider>
              <v-icon>mdi-chevron-right</v-icon>
            </template>
          </v-breadcrumbs>
          <v-container class="pa-0 ma-0">
            <iframe
              :src="iframe.src"
              :width="iframe.width"
              :height="iframe.height"
              frameborder="0"
              ref="frameGrad"
              v-show="iframe.loaded"
              @load="loaded"
            ></iframe>
          </v-container>
        </material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  components: {
    MaterialCard: () => import("../components/material/Card"),
    MaterialStatsCard: () => import("../components/material/StatsCard"),
  },
  data: () => ({
    iframe: {
      src: "",
      loaded: false,
      height: null,
      width: "100%",
      originalWidth: 1220,
      originalHeight: 3500,
      autoResize: {
        active: true,
        timeout: 700,
        timer: null,
      },
    },
    bread: [
      {
        text: "Home",
        href: location.origin + (pathName ? ("/" + pathName) : ''),
      },
      {
        text: "PDI/PPI 2020-2024",
        href: location.origin + (pathName ? ("/" + pathName) : '') + '/pdi-2020-2024',//'/pdi-2020-2024',
      },
      {
        text: "Painel da Meta PDI/PPI",
        active: true,
      },
    ],
  }),
  computed: {
    // Computa a última parte do path atual
    lastPartOfPath() {
      // Obtenha o caminho atual da URL
      const currentPath = this.$route.path;
      // Use `split` para dividir o caminho nas barras (`/`) e pegue o último elemento
      const pathSegments = currentPath.split("/");
      let numero = pathSegments[pathSegments.length - 1];
      numero = numero == "" || numero == "pdi-2020-2024" || numero == "pdi-2025-2030" ? "home" : numero;
      return numero;
    },
    hideIframe() {
      return this.lastPartOfPath == "home";
    },
    desiredPath() {
      switch (this.lastPartOfPath) {
        case "1.1":
        case "1.2":
        case "1.4":
        case "2.1":
        case "4.1":
        case "5.1":
        case "6.1":
        case "home": // home é uma visão geral do PDI
          return "https://lookerstudio.google.com/embed/reporting/ac4cbca1-1bf4-42f4-8c9e-2c059766adc4/page/p_tblqca5kkd";
        case "1.2":
          return "https://metabase.ufms.br/public/dashboard/af32dd12-d26b-4bda-8617-b0b7335c42dc";
        case "1.3":
          return "https://metabase.ufms.br/public/dashboard/064a13b3-7d3c-4463-972c-01ffb57867d4";
        case "1.4":
          return "https://metabase.ufms.br/public/dashboard/bfac40f3-11f5-466c-861f-ef78deee1488";
        case "1.5":
          return "https://metabase.ufms.br/public/dashboard/0dd8cbe4-80a7-4be8-bba6-1d7b8c7b4c56";
        case "1.6":
          return "https://metabase.ufms.br/public/dashboard/bfac40f3-11f5-466c-861f-ef78deee1488";
        case "1.7":
          return 'https://metabase.ufms.br/public/dashboard/af32dd12-d26b-4bda-8617-b0b7335c42dc'
        case "3.2":
          return "https://metabase.ufms.br/public/dashboard/b95bce2e-a1b8-438c-9f80-e00341662ae4";
        case "3.1":
          return "https://metabase.ufms.br/public/dashboard/22a7d6bb-5a20-413c-9413-e5fb8bfd9229";
        default:
          return "https://metabase.ufms.br/public/dashboard/d2b6aac5-9423-4e27-876f-dc5cbe4671ff";
      }
    },
    desiredTitle() {
      let numero = this.$route.path;
      // Use `split` para dividir o caminho nas barras (`/`) e pegue o último elemento
      numero = numero.split("/");
      numero = numero[numero.length - 1];
      numero = numero == "paipdi-2020-2024" ? "#erro" : numero;

      switch (this.lastPartOfPath[0]) {
        case "1":
          return " - Objetivo 1 - Aprimorar o Ensino de Graduação e de Pós-Graduação";
        case "2":
          return " - Objetivo 2 - Integrar a Universidade e a Sociedade por Meio da Extensão, Cultura, Esporte e Comunicação Científica e Social";
        case "3":
          return " - Objetivo 3 - Promover o Desenvolvimento Estudantil em Ambiente Inclusivo";
        case "4":
          return " - Objetivo 4 - Qualificar e Internacionalizar a Pesquisa Científica, o Desenvolvimento Tecnológico, Empreendedorismo e a Inovação";
        case "5":
          return " - Objetivo 5 - Consolidar as Práticas de Gestão, Governança, Compliance e Sustentabilidade";
        case "6":
          return " - Objetivo 6 - Promover o Desenvolvimento de Pessoal em Ambiente Acolhedor";
        /*
                case '1.1': return 'Sucesso da graduação';
                case '1.2': return 'Preenchimento de vagas na graduação';
                case '1.3': return 'Sucesso da pós-graduação stricto sensu';
                case '1.4': return 'Matriculados na pós-graduação lato sensu';
                case '1.5': return 'Preenchimento de vagas na pós-graduação stricto sensu';
                case '1.6': return 'Qualidade dos programas de pós-graduação stricto sensu';
                case '1.7': return 'Qualidade dos cursos de graduação';
                case '2.1': return 'Publicações da Editora UFMS';
                case '2.2': return 'Interação nas mídias sociais';
                case '2.3': return 'Atendimentos na extensão, na cultura e no esporte';
                case '3.1': return 'Estudantes em vulnerabilidade socioeconômica beneficiários da assistência estudantil';
                case '3.2': return 'Sucesso acadêmico dos beneficiários da assistência estudantil';
                case '4.1': return 'Estudantes da graduação que participam de programas e projetos de ensino, pesquisa, extensão, empreendedorismo, inovação e desenvolvimento institucional';
                case '4.2': return 'Empreendimentos tecnológicos e sociais incubados';
                case '4.3': return 'Pedidos de proteção intelectual depositados';
                case '4.4': return 'Acordos e parcerias para Ciência, Tecnologia e Inovação em âmbito nacional e internacional';
                case '4.5': return 'Impacto da produção científica e tecnológica';
                case '4.6': return 'Programas e projetos de extensão, pesquisa, empreendedorismo, ensino, inovação, sustentabilidade e desenvolvimento institucional vinculados aos Objetivos de Desenvolvimento Sustentável – ODS';
                case '5.1': return 'Melhoria de infraestrutura física';
                case '5.2': return 'Edificações adaptadas à acessibilidade';
                case '5.3': return 'Melhoria em Tecnologia da Informação e serviços digitais';
                case '5.4': return 'Execução orçamentária de custeio e capital';
                case '5.5': return 'Índice de Gestão e Governança institucional';
                case '5.6': return 'Atendimento ao Plano de Logística Sustentável';
                case '6.1': return 'Servidores beneficiados com ações de desenvolvimento pessoal';
                case '6.2': return 'Servidores beneficiados com ações de saúde e qualidade de vida';
                */
        default:
          return "2020/2024";
      }
    },
  },
  mounted() {
    // Quando o componente for montado, obtenha o caminho atual da URL
    const currentPath = this.$route.path;
    this.iframe.src = this.desiredPath;
    this.iframe.css.display = "none";
  },
  beforeDestroy() {
    if (this.iframe.autoResize.timer) {
      clearInterval(this.iframe.autoResize.timer);
    }
  },
  watch: {
    // Observe as mudanças na rota atual
    "$route.path": function(newPath, oldPath) {
      // Use `window.location.href` ou `window.location.replace` para recarregar a página
      this.iframe.loaded = false;
      setTimeout(() => {
        this.iframe.loaded = true;
      }, 1000); // delay
      this.iframe.src = this.desiredPath;
    },
  },
  methods: {
    loaded: function() {
      if (this.iframe.autoResize.active) {
        this.iFrameResize();
        this.iframe.autoResize.timer = setInterval(
          this.iFrameResize,
          this.iframe.autoResize.timeout
        );
      }

      setTimeout(() => {
        this.iframe.loaded = true;
      }, 1000); // delay
    },

    iFrameResize() {
      if (!this.$refs.frameGrad) {
        return;
      }

      let parentWidth = this.$refs.frameGrad.parentElement.clientWidth;
      let ratio = this.iframe.originalHeight / this.iframe.originalWidth;
      this.iframe.height = parseInt(ratio * parentWidth) + "px";
      this.iframe.width = "100%";
    },
  },
};
</script>

<style lang="scss">
.tim-note {
  bottom: 10px;
  color: #c0c1c2;
  display: block;
  font-weight: 400;
  font-size: 13px;
  line-height: 13px;
  left: 0;
  margin-left: 20px;
  width: 260px;
}
</style>
